const labels = {
  'errors.notfoundError.title': 'Erreur 404 Page non trouvée',
  'errors.internalError.title': 'Erreur 500 Erreur du serveur interne',
  'errors.internalErrorAdvisor.title': 'Erreur du serveur interne',
  'errors.forbiddenError.title': '403 Erreur Accès refusé',
  'errors.forbiddenErrorUnlicensed.title': 'Accès refusé',
  'errors.forbiddenErrorUnlicensed.message':
    'Nous sommes désolés, nous ne pouvons pas traiter votre demande.  Veuillez réessayer plus tard ou contacter le service de soutien aux conseillers par téléphone au 1 877 654-2757 ou par courriel à am_brokersupport@manulife.ca.',
  'errors.internalErrorAdvisor.message':
    'Nous sommes désolés, nous ne pouvons pas traiter votre demande.  Veuillez réessayer plus tard.',
  'errors.forbiddenErrorWeblink.title': '404 Erreur Page introuvable',
  'errors.forbiddenErrorWeblink.message':
    "Il se peut que la page n'existe plus, mais d'abord, assurez-vous que l'adresse du site Web que vous avez entrée est exacte :",
  'errors.forbiddenErrorWeblink.retry1': 'si vous avez copié et collé un lien, veillez à sélectionner le lien en entier.',
  'errors.forbiddenErrorWeblink.retry2': "si vous avez entré un lien dans la barre d'adresse, essayez de l'entrer de nouveau.",
  'errors.message.retry1':
    'Il se peut que la page n’existe plus, mais d’abord, assurez-vous que l’adresse du site Web que vous avez entrée est exacte :',
  'errors.message.retry2': 'si vous avez copié et collé un lien, veillez à sélectionner le lien en entier.',
  'errors.message.retry3': 'si vous avez entré un lien dans la barre d’adresse, essayez de l’entrer de nouveau.',
  'errors.message.retry4': 'Si cela ne fonctionne toujours pas, veuillez communiquer avec le service d’assistance.'
};

export default labels;
